import { render } from "./App.vue?vue&type=template&id=1ea9dff0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1ea9dff0&lang=css"
import "./App.vue?vue&type=style&index=1&id=1ea9dff0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea9dff0"]])

export default __exports__